import { useTheme } from "@mui/material/styles";
import useConfig from "../../../hooks/useConfig";
import { ThemeMode } from "../../../utils/types/config";
export var MainCardStyles = function (border, boxShadow, shadow) {
    var mode = useConfig().mode;
    var theme = useTheme();
    var defaultShadow = mode === ThemeMode.DARK
        ? "0 2px 14px 0 rgb(33 150 243 / 10%)"
        : "0 2px 14px 0 rgb(32 40 45 / 8%)";
    var headerSX = {
        textTransform: "uppercase",
        "& .MuiCardHeader-action": { mr: 0 },
    };
    var cardSX = {
        border: border ? "1px solid" : "none",
        borderColor: theme.palette.grey[200],
        ":hover": {
            boxShadow: boxShadow ? shadow || defaultShadow : "inherit",
        },
    };
    return { headerSX: headerSX, cardSX: cardSX };
};
